module.exports = __webpack_public_path__ + "static/media/400151_01.f2b8bcfd.png";